import * as actions from "./actionTypes";
import axios from "../../axios_call";
import swal from "sweetalert";
import {
  BASE_URL,
  getLocalStorageValue,
  getUserId,
} from "../../components/Helpers/helpers";

const billListStart = () => {
  return {
    type: actions.BILL_LIST_START,
  };
};

const billListFail = (error) => {
  return {
    type: actions.BILL_LIST_FAIL,
    error: error,
  };
};

const billListSuccess = (message, data, page) => {
  return {
    type: actions.BILL_LIST_SUCCESS,
    message,
    data: data.data,
    totalRecords: data.totalRecords,
    currentPage: data.currentPage,
    totalPages: data.totalPages,
    limit: data.limit,
    count: data.count,
    page,
  };
};

const billDeleteAction = (id) => {
  return {
    type: actions.BILL_DELETE,
    id: id,
  };
};

const billAddEditStart = () => {
  return {
    type: actions.BILL_ADD_EDIT_START,
  };
};

const billAddEditFail = (error) => {
  return {
    type: actions.BILL_ADD_EDIT_FAIL,
    error: error,
    redirectTo: null,
  };
};

const billAddEditSuccess = (message, data) => {
  return {
    type: actions.BILL_ADD_EDIT_SUCCESS,
    message: message,
    data: data,
    redirectTo: "/bill",
  };
};

const billDetail = (data, error) => {
  return {
    type: actions.BILL_DETAIL,
    data: data,
    error: error,
  };
};

const billStatus = (data, error) => {
  return {
    type: actions.BILL_STATUS,
    data: data,
    error: error,
  };
};

const billfilterList = (text) => {
  return {
    type: actions.BILL_LIST_FILTER,
    text: text,
  };
};
const constructUrlWithParams = (baseUrl, params) => {
  const query = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
    )
    .join("&");
  return `${baseUrl}?${query}`;
};

export const billList = (params = {}) => {
  return (dispatch) => {
    dispatch(billListStart());
    const storedPage = Number(localStorage.getItem("billsPage")) || 1;

    const OrganisationID = getLocalStorageValue("OrganisationID");
    const currentUser = getUserId();

    const storedFilter = localStorage.getItem("billFilter");
    const storedSort = localStorage.getItem("billSort");
    if (storedSort) {
      try {
        params.sort = JSON.parse(storedSort);
      } catch (e) {
        params.sort = [];
      }
    }

    if (storedFilter) {
      try {
        params.filters = JSON.parse(storedFilter);
      } catch (e) {
        params.filters = [];
      }
    }
    const queryParams = {
      OrganisationID,
      page: storedPage || 1,
      limit: params.limit || 10,
      role_name: currentUser?.Role?.Name || "User",
      UserId: currentUser?.UserID,
      SupplierName: params.SupplierName || "",
      Reference: params.Reference || "",
      Status: params.Status || "",
      Collaborator: params.Collaborator || "",
      Spend: params.Spend || "",
      Receive: params.Receive || "",
      MinDate: params.minDate || "",
      MaxDate: params.MaxDate || "",
      Description: params.Description || "",
      search: params.search || "",
      AccountID: params.AccountID || "",
      latestRecords: params.latestRecords || false,
      CurrencyCode: params.CurrencyCode || "",
    };
    /* ================= FILTER ================= */

    let finalFilters = [];

    if (params.filters && Array.isArray(params.filters)) {
      finalFilters = params.filters;
    }

    const cleanedFilters = finalFilters.filter(
      (f) =>
        f?.name &&
        (f.key === "empty" || f.key === "notEmpty" || f.value !== ""),
    );

    if (cleanedFilters.length > 0) {
      queryParams.filters = JSON.stringify(cleanedFilters);
    }

    let finalSort = [];

    if (params.sort && Array.isArray(params.sort)) {
      finalSort = params.sort;
    }

    const cleanedSort = finalSort.filter((s) => s?.field && s?.order);

    if (cleanedSort.length > 0) {
      queryParams.sort = JSON.stringify(cleanedSort);
    }

    /* ================= CLEAN ================= */

    Object.keys(queryParams).forEach((key) => {
      if (
        queryParams[key] === "" ||
        queryParams[key] === null ||
        queryParams[key] === undefined
      ) {
        delete queryParams[key];
      }
    });

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${BASE_URL}/invoice/bill?${queryString}`;

    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          dispatch(
            billListSuccess(
              response.data.message,
              response.data,
              queryParams.page,
            ),
          );
        } else {
          dispatch(billListFail(response.message || "Unknown error"));
        }
      })
      .catch((error) => {
        dispatch(billListFail(error.message || "Network error"));
      });
  };
};

export const getAllbillList = (params) => {
  return (dispatch) => {
    return axios
      .get(`${BASE_URL}/invoice`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(billDetail(response.data, ""));
          return response;
        } else {
          dispatch(billDetail(null, "Invalid bill detail"));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(billDetail(null, error.message));
        return { data: null };
      });
  };
};

export const updateBillLineItem = (InvoiceID, LineItemID, payload) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/${InvoiceID}/line-item/${LineItemID}`, payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: actions.UPDATE_BILL_LINE_ITEM_SUCCESS,
            data: response.data,
          });
          return response;
        } else {
          dispatch({
            type: actions.UPDATE_BILL_LINE_ITEM_FAIL,
            error: "Failed to update line item",
          });
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch({
          type: actions.UPDATE_BILL_LINE_ITEM_FAIL,
          error: error.message,
        });
        return { data: null };
      });
  };
};

export const updateBillDetails = (InvoiceID, payload) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/update-bill-details/${InvoiceID}`, payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: actions.UPDATE_BILL_DETAILS_SUCCESS,
            data: response.data,
          });
          return response;
        } else {
          dispatch({
            type: actions.UPDATE_BILL_DETAILS_FAIL,
            error: "Failed to update bill details",
          });
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch({
          type: actions.UPDATE_BILL_DETAILS_FAIL,
          error: error.message,
        });
        return { data: null };
      });
  };
};

export const getbillupdate = (
  InvoiceID,
  UserID,
  CurrentLoginedUserId,
  OrganisationID,
) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/update-invoice-user`, {
        type: "invoice",
        EntityID: InvoiceID,
        InvoiceID: InvoiceID,
        UserID: UserID,
        CurrentLoginedUserId: CurrentLoginedUserId,
        currentUserId: CurrentLoginedUserId,
        OrganisationID: OrganisationID,
      })
      .then((response) => {
        if (response.status === 200) {
          dispatch(billDetail(response.data, ""));
          dispatch(getAllbillList());
          swal("Successfully assigned!", {
            icon: "success",
          });
          return response;
        } else {
          dispatch(billDetail(null, "Invalid bill detail"));
          swal("Error", "Something went to wrong!", "error");
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(billDetail(null, error.message));
        return { data: null };
      });
  };
};

export const billDelete = (id, token) => {
  return (dispatch) => {
    axios
      .delete("SuperAdmin/deletetransaction?transactionid=" + id)
      .then((response) => {
        if (response.data.status) {
          dispatch(billDeleteAction(id));
        }
      });
  };
};

export const getbillDetail = (id) => {
  return (dispatch) => {
    return axios
      .get(`${BASE_URL}/invoice/invoice-detail/${id}`)
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(billDetail(response.data, ""));
          return response;
        } else {
          dispatch(billDetail(null, "Invalid transaction detail"));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(billDetail(null, error.message));
        return { data: null };
      });
  };
};
export const setBillStatus = (id, user) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/read-invoice-status/${id}`, {
        user,
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(billStatus(response.data, ""));
          return response;
        } else {
          dispatch(billStatus(null, "Invalid transaction detail"));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(billStatus(null, error.message));
        return { data: null };
      });
  };
};

export const getApprovedBillStatus = (InvoiceID, currentUserId) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/update-invoice-status`, {
        InvoiceID,
        currentUserId,
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(billDetail(response.data, ""));
          return response;
        } else {
          dispatch(billDetail(null, "Failed to update transaction status."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(billDetail(null, error.message));
        return { data: null };
      });
  };
};

export const getDeletedBill = (InvoiceID) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/delete-invoice-document`, {
        InvoiceID,
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(billDetail(response.data, ""));
          return response;
        } else {
          dispatch(billDetail(null, "Failed to delete bill document."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(billDetail(null, error.message));
        return { data: null };
      });
  };
};

export const getVerifiedBillStatus = (InvoiceID, currentUserId) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/verified-invoice`, {
        InvoiceID,
        currentUserId,
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(billDetail(response.data, ""));
          return response;
        } else {
          dispatch(billDetail(null, "Failed to update transaction status."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(billDetail(null, error.message));
        return { data: null };
      });
  };
};

export const getUnverifiedBill = (InvoiceID) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/delete-invoice-document`, {
        InvoiceID,
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(billDetail(response.data, ""));
          return response;
        } else {
          dispatch(billDetail(null, "Failed to delete transaction document."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(billDetail(null, error.message));
        return { data: null };
      });
  };
};

export const postBillAttachmentsFilename = (
  InvoiceID,
  OrganisationID,
  FileName,
) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/invoice/${InvoiceID}/Attachments/${FileName}`, {
        InvoiceID,
        OrganisationID,
        FileName,
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(billDetail(response.data, ""));
          dispatch(getAllbillList());
          swal("Post Attachment Successfully!", {
            icon: "success",
          });
          return response;
        } else {
          dispatch(billDetail(null, "Failed to delete bill document."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(billDetail(null, error.message));
        return { data: null };
      });
  };
};

export const BillDetail = (id) => {
  return (dispatch) => {
    axios.get("SuperAdmin/gettransactionbyid?id=" + id).then((response) => {
      if (response.data.result) {
        dispatch(billDetail(response.data.result, ""));
      } else {
        dispatch(billDetail(null, "Invalide bill Detail"));
      }
    });
  };
};

export const billAddEdit = (param) => {
  return (dispatch) => {
    dispatch(billAddEditStart());
    axios
      .post("SuperAdmin/addupdatetransaction", param)
      .then((response) => {
        if (response.data.status) {
          const data = response.data.result;
          const msg = response.data.message;
          dispatch(billAddEditSuccess(msg, data));
        } else {
          dispatch(billAddEditFail(response.data.message));
        }
      })
      .catch((error) => {
        dispatch(billAddEditFail(error.message));
      });
  };
};

export const addEditBillErrorNull = () => {
  return (dispatch) => {
    dispatch(billAddEditFail(null));
  };
};

export const billListFilter = (filterText) => {
  return (dispatch) => {
    dispatch(billfilterList(filterText));
  };
};
